import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/**
 * views/platform/productsSupplier/form submits the whole form, which the slice
 * defines as `{id, name}`. `balance` and `total_sold_devices` are derived from
 * the supplier's transactions and are not in the form.
 */
export default defineInlineEdit({
  api: "productSupplier",
  permission: "supplier_product_edit",
  hydrate: false,
  toPayload: (source) => ({ name: source.name ?? "" }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
  },
});
